(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ai-chat', {
            parent: 'app',
            url: '/ai-chat',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Home'
            },
            onEnter: ['$state', function($state) {
                $state.go('home');
            }]
        });
    }
})();
